import React from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type Props = {
	children: React.ReactNode;
};

export const TaskTypeCard: React.FC<Props> = ({ children }: Props) => (
	<Flex xcss={TaskTypeCardStyles}>{children}</Flex>
);

export const TaskItemCard: React.FC<Props> = ({ children }: Props) => (
	<Flex xcss={TaskItemCardStyles}>{children}</Flex>
);

const TaskTypeCardStyles = xcss({
	flexDirection: 'column',
	borderRadius: 'border.radius.100',
	boxShadow: 'elevation.shadow.raised',
	border: `1px solid ${token('color.border')}`,

	padding: 'space.150',
	flex: '1 1 0',
	width: '100%',
});

const TaskItemCardStyles = xcss({
	flexDirection: 'column',
	gap: 'space.100',

	flex: '1 1 0',
	width: '100%',
});
